module.exports = __webpack_public_path__ + "img/support_head.3ac7900f.jpg";